import CountryStateSelector from '~/js/components/form-controls/CountryStateSelector';
import LongDatePicker from '~/js/components/form-controls/LongDatePicker';
import ZipCodeInput from '~/js/components/form-controls/ZipCodeInput';
import CustomRecaptcha from '~/js/components/form-controls/CustomRecaptcha';
import countryPhoneCodes from '~/js/modules/country-phone-codes';
// create new array for countries and appending a new object that represents default value
const countries = [
    {
      name: 'Select A Country',
      id: '',
      regionCode: '',
      code: ''
    },
    ...window.beaches_app.page.countries
  ];
  
  // create new array for states and appending a new object that represents default value
  const states = [
    ...window.beaches_app.page.states
  ];
  

  const giftOption = $('input[name="option"]');
  let actualOption = '';


  ReactDOM.render(
    <CustomRecaptcha
      wrapperClassName="xs-12 lg-12"
    />,
    document.getElementById('google-recaptcha')
  );
  
  ReactDOM.render(
    <CountryStateSelector
      countries={ countries }
      states={ states }
      countryName="country"
      stateName="state"
      stateLabelWrapper="xs-12 sm-12 md-12 lg-3"
      stateInputWrapper="xs-12 sm-12 md-12 lg-9"
      countryLabelWrapper="xs-12 sm-12 md-12 lg-3"
      countryInputWrapper="xs-12 sm-12 md-12 lg-9"
    />,
    document.getElementById('country-state-selector')
  );

  ReactDOM.render(
    <LongDatePicker
      wrapperClassName="xs-12 sm-12 md-12 lg-12"
      monthClassName="xs-4 sm-4 md-4 lg-3"
      dayClassName="xs-4 sm-4 md-4 lg-3"
      yearClassName="xs-4 sm-4 md-4 lg-3"
      labelWrapper="xs-12 sm-12 md-12 lg-3"
      labelName="Arrival Date"
      label={true}
      isRequired={true}
    />,
    document.getElementById('arrival-date')
  );

  ReactDOM.render(
    <ZipCodeInput zipCodeName="zipCode" zipCodeInputWrapper="xs-8 lg-3" />,
    document.getElementById('zipcode-input')
  );

  $(document).ready(() => {

    var x = document.getElementsByClassName("dropdown-wrapper")[0];
     x.id="extra-size";

     var element = document.getElementById("extra-size");
     element.classList.remove("xs-12", "sm-12", "md-12","lg-12");

});

  const form = $('.fall-4-beaches-form');
  const submitForm = document.getElementById('submit-button');
  

  giftOption.change(e => {
    actualOption = e.target.value;
  });

  submitForm.addEventListener('click', e => {
    if($('[name=month]').val() > 0 && $('[name=day]').val() && $('[name=year]').val()) {
      $('[name=arrivalDate]').val($('[name=month]').val() + '/' + $('[name=day]').val() + '/' + $('[name=year]').val()); 
    }
    $('#resort').val($('#resortCode').val());

    form.attr(
        'data-location',
        `/deals/fall-4-beaches-registration/thank-you?source=${beaches_app.page.promotionId}&gift=${actualOption}`
      );

  });

// Form validations
import '~/js/modules/fend';

form.fend({
  rules: {
    firstName: 'lettersOnly',
    lastName: 'lettersOnly',
    bookingNumber: 'alphanumeric',
    city: 'lettersOnly',
    arrivalDate: 'date',
  },
  isMultiPart: false
});